import React, { useState } from 'react';
import OwnesiteUrl from './OwnesiteUrl';
import MerchantLogo from './MerchantLogo';

const MerchantPage = () => {
  const [selected, setSelected] = useState("option1"); // store selected value

  const handleChange = (event) => {
    const value = event.target.value;
    setSelected(value);
    checkRadio(value); // pass the new value directly
  };

  const checkRadio = (value) => {
    if (value) {
      // console.log("Selected:", value);
    } else {
      // console.log("No option selected");
    }
  };

  return (
    <div className='container d-flex  justify-content-center  flex-column my-auto pt-3 px-0' >
      <div className="form-check">
        <input
          type="radio"
          className="form-check-input"
          id="radio1"
          name="optradio"
          value="option1"
          checked={selected === "option1"}
          onChange={handleChange}
        />
        <label className="form-check-label" htmlFor="radio1">
          Merchant Own Site Url
        </label>
      </div>
      {selected === "option1" ? <OwnesiteUrl /> : null}
      <div className="form-check">
        <input
          type="radio"
          className="form-check-input"
          id="radio2"
          name="optradio"
          value="option2"
          checked={selected === "option2"}
          onChange={handleChange}
        />
        <label className="form-check-label" htmlFor="radio2">
          Create your Own Site
        </label>
      </div>
      {selected === "option2" ? <MerchantLogo /> : null}
    </div>
  );
};

export default MerchantPage;
